import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PoaGestionService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getPoaGestion(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaGestiones', { headers: this.header(this.token) });
  }

  getPoaGestionById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaGestion/' + id, { headers: this.header(this.token) });
  }

  postPoaGestion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaGestion', bodyString, { headers: this.header(this.token) });
  }

  putPoaGestion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaGestion', bodyString, { headers: this.header(this.token) });
  }

  poaGestionVigencia(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaGestionVigencia', bodyString, { headers: this.header(this.token) });    
  }

  deletePoaGestion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaGestion/' + id, { headers: this.header(this.token) });
  }

  postPoaGestionAprobacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaGestionAprueba', bodyString, { headers: this.header(this.token) });
  }

  getPoaEtapas(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaEtapas', { headers: this.header(this.token) });
  }

  putReformulacionPoa(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaGestionCambiarEtapa', bodyString, { headers: this.header(this.token) });
  }

  getMemoriaEtapas(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaMemoria/1', { headers: this.header(this.token) });
  }
}
